import { RefObject } from 'react';
import { getTargetOrigin } from './getTargetOrigin';

/**
 * Reloads the preview iframe by sending a reload message
 * Used after creating pages to update the navigation
 */
export const reloadIframe = (iframeRef: RefObject<HTMLIFrameElement>) => {
  if (iframeRef?.current?.contentWindow) {
    iframeRef.current.contentWindow.postMessage(JSON.stringify({ type: 'reload' }), getTargetOrigin());
  }
};
